/**
 * Verbose notification / supervisor console logs.
 * Off unless localStorage `studema.debug.notifications` is `"1"`.
 *
 * Enable in the browser console, then reload:
 *   localStorage.setItem('studema.debug.notifications', '1')
 * Silence again:
 *   localStorage.removeItem('studema.debug.notifications')
 */
const NOTIFICATION_DEBUG_KEY = 'studema.debug.notifications';

export function isNotificationDebugEnabled(): boolean {
    try {
        return typeof localStorage !== 'undefined'
            && localStorage.getItem(NOTIFICATION_DEBUG_KEY) === '1';
    } catch {
        return false;
    }
}
